export const ContactTypes = {
  CUSTOMER: "customer",
  PARTNER: "partner",
  VENDOR: "vendor",
  INTERNAL: "internal"
};

export const ContactTypesCondensed = Object.keys(ContactTypes).reduce(
  (acc, key) => {
    if (key !== "PARTNER" && key !== "VENDOR") {
      acc[key] = ContactTypes[key];
    }
    return acc;
  },
  { PARTNER_VENDOR: "partnerVendor" }
);

export const ContactTypeLabels = {
  [ContactTypes.CUSTOMER]: "Customer",
  [ContactTypes.PARTNER]: "Partner",
  [ContactTypes.VENDOR]: "Vendor",
  [ContactTypes.INTERNAL]: "Internal"
};

export const VendorSubtypes = {
  ARCHITECT: "architect",
  BUILDER: "builder",
  CONSULTANT: "consultant",
  EQUIPMENT: "equipment",
  FURNITURE: "furniture",
  GENERAL: "general",
  INTERIOR: "interior_designer",
  MASONRY: "masonry",
  NURSERY: "nursery"
};

export const VendorSubtypeLabels = {
  [VendorSubtypes.ARCHITECT]: "Architect",
  [VendorSubtypes.BUILDER]: "Builder",
  [VendorSubtypes.CONSULTANT]: "Consultant",
  [VendorSubtypes.EQUIPMENT]: "Equipment",
  [VendorSubtypes.FURNITURE]: "Furniture",
  [VendorSubtypes.GENERAL]: "General",
  [VendorSubtypes.INTERIOR]: "Interior Designer",
  [VendorSubtypes.MASONRY]: "Masonry",
  [VendorSubtypes.NURSERY]: "Nursery"
};

export const InternalSubtypes = {
  PROJECT_MANAGER: "project_manager",
  OFFICE_STAFF: "office_staff",
  CREW_LABORER: "crew_laborer",
  DESIGN: "design_team"
};

export const InternalSubtypeLabels = {
  [InternalSubtypes.PROJECT_MANAGER]: "Project Manager",
  [InternalSubtypes.OFFICE_STAFF]: "Office Staff",
  [InternalSubtypes.CREW_LABORER]: "Crew Laborer",
  [InternalSubtypes.DESIGN]: "Design Team"
};

export const PartnerSubtypes = {
  ARCHITECT: "architect",
  BUILDER: "builder",
  INT_DESIGNER: "interior_designer"
};

export const PartnerSubtypeLabels = {
  [PartnerSubtypes.ARCHITECT]: "Architect",
  [PartnerSubtypes.BUILDER]: "Builder",
  [PartnerSubtypes.INT_DESIGNER]: "Interior Designer"
};
